<template>
  <div class="view about">
    <div class="container">
      <div class="title">{{ $t('about') }}</div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
@use '@/styles/fonts.scss';

.view {
  background: colors.$main-color;
  display: flex;
  align-items: center;
  justify-content: center;

  .container {
    max-width: calc(100% - 32px);
    width: 590px;
    height: auto;
    padding: 64px 96px;
    box-sizing: border-box;
    background: colors.$white-color;
    border-radius: 6px;
    box-shadow: 0 8px 24px rgba(colors.$darkblue-color, 0.2);

    @media screen and (max-width: 700px) {
      padding: 48px 32px;
    }

    .title {
      font-family: fonts.$title-font;
      color: colors.$darkblue-color;
      font-size: 24px;
      font-weight: 600;
      text-align: left;
      margin: 0 0 32px;
    }
  }
}
</style>
